import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "happylab_token";

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

// attach token on every request
api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// expose for components that want to listen for forced logouts
let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => {
    onUnauthorized = fn;
};

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const token = localStorage.getItem(TOKEN_KEY);
            const url = error.config?.url || "";
            // Interactive-auth endpoints legitimately return 401 for wrong credentials
            // (e.g. /auth/change-password when the user mistypes their old password,
            // /auth/login when the password is wrong). Those are form errors, not
            // session expiry — never force-logout the user.
            const isInteractiveAuth =
                url.endsWith("/auth/change-password") ||
                url.endsWith("/auth/login") ||
                url.endsWith("/auth/register");
            // Only force-logout if we *had* a token (i.e. it just expired) AND the
            // failed call wasn't an interactive auth submission.
            if (token && !isInteractiveAuth && onUnauthorized) {
                onUnauthorized();
            }
        }
        return Promise.reject(error);
    }
);
